var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmexIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 30,
    viewBox: "0 0 48 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46.1429,
    height: 28.1032,
    rx: 4.5,
    stroke: "#AAAAAA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7825 9.88974L29.3234 8.50311H31.7185V5.99219H15.3389V21.8822H31.7185V19.3713H29.4392L28.5894 18.4344L27.7395 19.3713H21.3267V14.3494H19.202L21.8675 8.54058H24.4558L25.0739 9.85226V8.54058H28.2803L28.7825 9.88974ZM27.0055 10.8266V10.2645L27.2373 10.8266L28.3189 13.5999H29.3234L30.405 10.8266L30.5982 10.2645V13.5624H31.7185V9.32759H29.8642L29.0143 11.4637L28.7825 12.0634L28.5507 11.4637L27.7008 9.32759H25.8465V13.5624H27.0055V10.8266ZM24.6104 13.5624H25.8852L23.9536 9.32759H22.447L20.5154 13.5624H21.7903L22.138 12.7379H24.2627L24.6104 13.5624ZM22.9878 10.7892L23.2196 10.2645L23.4514 10.7892L23.915 11.876H22.5629L22.9878 10.7892ZM22.2152 14.3494V18.5843H25.8465V17.6848H23.2969V16.9353H25.7693V16.0359H23.2969V15.2863H25.8465V14.3869L22.2152 14.3494ZM29.9415 18.5468H31.3708L29.3234 16.4481L31.3708 14.3494H29.9415L28.628 15.7361L27.3145 14.3494H25.8465L27.894 16.4856L25.8465 18.5843H27.2373L28.5507 17.1976L29.9415 18.5468ZM30.4823 16.4481L31.7185 17.6848V15.2489L30.4823 16.4481Z",
    fill: "#006FCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmexIcon);
export default __webpack_public_path__ + "static/media/amex-icon.50079adc93980ecd4db3809c61f6f192.svg";
export { ForwardRef as ReactComponent };